import find from './find'
import image from './image'

const markerhelper = {
    find,
    image,
}

export default markerhelper